export const PURCHASE_VOUCHER_URL = 'https://item.taobao.com/item.htm?id=994432052250';
